function formatPrice(amount) {
  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: 'ILS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

// Global update lock
let isUpdating = false;

// Get current filter values from URL
function getCurrentFilterValues() {
  const params = new URLSearchParams(window.location.search);
  const gte = parseFloat(params.get('filter.v.price.gte')) || 0;
  const lte = parseFloat(params.get('filter.v.price.lte')) || null;
  return { gte, lte };
}

// Initialize slider
function initSlider(wrapper) {
  const track = wrapper.querySelector('.price-slider-track');
  const minPoint = wrapper.querySelector('.price-points.min');
  const maxPoint = wrapper.querySelector('.price-points.max');
  if (!track || !minPoint || !maxPoint) return;

  // Read raw max from .max-range (e.g., "480000" or "₪480,000.00")
  const rawMaxText = wrapper.querySelector('.max-range').textContent.trim();
  const rawMax = parseFloat(rawMaxText.replace(/[^\d.-]/g, '')) || 100;

  // Detect if in minor units (common in Shopify: 480000 = ₪4,800.00)
  const isMinorUnits = rawMax >= 10000 && rawMax % 100 === 0;
  const scale = isMinorUnits ? 100 : 1;

  const absMax = rawMax / scale; // True max in ILS (e.g., 4800)
  if (absMax <= 0) return;

  let isDragging = null;
  let minPercent = 0;
  let maxPercent = 100;
  const minGapPercent = 5;

  track.style.direction = 'ltr';

  function updatePointPosition(point, percent) {
    point.style.left = `${percent}%`;
  }

  function clampPercent(percent) {
    return Math.max(0, Math.min(100, percent));
  }

  function setMinPercent(val) {
    minPercent = clampPercent(Math.min(val, maxPercent - minGapPercent));
    updatePointPosition(minPoint, minPercent);
  }

  function setMaxPercent(val) {
    maxPercent = clampPercent(Math.max(val, minPercent + minGapPercent));
    updatePointPosition(maxPoint, maxPercent);
  }

  function pxToPercent(px) {
    const rect = track.getBoundingClientRect();
    const x = px - rect.left;
    return (x / rect.width) * 100;
  }

  function percentToPrice(percent) {
    return (percent / 100) * absMax;
  }

  function priceToPercent(price) {
    return (price / absMax) * 100;
  }
  // if (isUpdating) return;

  function broadcastChange(submit = false) {
    if (isUpdating) return;
    isUpdating = true;

    const minPrice = Math.round(percentToPrice(minPercent));
    const maxPrice = Math.round(percentToPrice(maxPercent));

    // Update Shopify inputs in correct units (ILS, not minor)
    document.querySelectorAll('input[name="filter.v.price.gte"]').forEach(i => i.value = minPrice);
    document.querySelectorAll('input[name="filter.v.price.lte"]').forEach(i => i.value = maxPrice);

    // Update OUR slider labels only (if exist)
    const ourMinLabel = wrapper.closest('.price-filter-main')?.querySelector('.current-min');
    const ourMaxLabel = wrapper.closest('.price-filter-main')?.querySelector('.current-max');
    if (ourMinLabel) ourMinLabel.textContent = formatPrice(minPrice);
    if (ourMaxLabel) ourMaxLabel.textContent = formatPrice(maxPrice);

    // Sync OTHER sliders
    document.querySelectorAll('.price-slider-wrap').forEach(w => {
      if (w === wrapper) return;
      const wRawMaxText = w.querySelector('.max-range').textContent.trim();
      const wRawMax = parseFloat(wRawMaxText.replace(/[^\d.-]/g, '')) || 100;
      const wIsMinor = wRawMax >= 10000 && wRawMax % 100 === 0;
      const wScale = wIsMinor ? 100 : 1;
      const wAbsMax = wRawMax / wScale;

      const minP = (minPrice / wAbsMax) * 100;
      const maxP = (maxPrice / wAbsMax) * 100;

      w.querySelector('.price-points.min').style.left = `${clampPercent(minP)}%`;
      w.querySelector('.price-points.max').style.left = `${clampPercent(maxP)}%`;
    });

    if (submit) {
      setTimeout(() => {
        document.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach(input => {
          input.dispatchEvent(new InputEvent('input', { bubbles: true, cancelable: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        isUpdating = false;
      }, 50);
    } else {
      isUpdating = false;
    }



    // Sync OTHER sliders – fixed version
    // document.querySelectorAll('.price-slider-wrap').forEach(w => {
    //   if (w === wrapper) return;
    //   const wAbsMax = getAbsMax(w); // add this helper or recalculate
    //   if (!wAbsMax) return;

    //   const minP = (minPrice / wAbsMax) * 100;
    //   const maxP = (maxPrice / wAbsMax) * 100;

    //   w.querySelector('.price-points.min').style.left = `${clampPercent(minP)}%`;
    //   w.querySelector('.price-points.max').style.left = `${clampPercent(maxP)}%`;
    // });
    // Sync OTHER sliders – FIXED
    document.querySelectorAll('.price-slider-wrap').forEach(w => {
      if (w === wrapper) return;

      const rawMaxText = w.querySelector('.max-range').textContent.trim();
      const rawMax = parseFloat(rawMaxText.replace(/[^\d.-]/g, '')) || 100;
      const isMinor = rawMax >= 10000 && rawMax % 100 === 0;
      const wAbsMax = rawMax / (isMinor ? 100 : 1);

      if (wAbsMax <= 0) return;

      const minP = (minPrice / wAbsMax) * 100;
      const maxP = (maxPrice / wAbsMax) * 100;

      w.querySelector('.price-points.min').style.left = `${clampPercent(minP)}%`;
      w.querySelector('.price-points.max').style.left = `${clampPercent(maxP)}%`;
    });
  
  }

  // === EVENT DELEGATION ===
  const startDrag = (e, type) => {
    e.preventDefault();
    isDragging = type;

    const moveHandler = moveEvent => {
      if (!isDragging) return;
      const clientX = moveEvent.touches ? moveEvent.touches[0].clientX : moveEvent.clientX;
      const percent = pxToPercent(clientX);
      if (isDragging === 'min') setMinPercent(percent);
      else if (isDragging === 'max') setMaxPercent(percent);
      broadcastChange(false);
    };

    const upHandler = () => {
      isDragging = null;
      document.removeEventListener('mousemove', moveHandler);
      document.removeEventListener('mouseup', upHandler);
      document.removeEventListener('touchmove', moveHandler);
      document.removeEventListener('touchend', upHandler);
      broadcastChange(true);
    };

    document.addEventListener('mousemove', moveHandler);
    document.addEventListener('mouseup', upHandler);
    document.addEventListener('touchmove', moveHandler, { passive: false });
    document.addEventListener('touchend', upHandler);
  };

  document.addEventListener('mousedown', e => {
    if (e.target === minPoint) startDrag(e, 'min');
    if (e.target === maxPoint) startDrag(e, 'max');
  }, true);

  document.addEventListener('touchstart', e => {
    if (e.target === minPoint) startDrag(e, 'min');
    if (e.target === maxPoint) startDrag(e, 'max');
  }, { passive: false, capture: true });

  document.addEventListener('click', e => {
    if (e.target === track) {
      const percent = pxToPercent(e.clientX);
      const distToMin = Math.abs(percent - minPercent);
      const distToMax = Math.abs(percent - maxPercent);
      if (distToMin < distToMax) setMinPercent(percent);
      else setMaxPercent(percent);
      broadcastChange(true);
    }
  }, true);

  // === RESTORE FROM URL ===
  // const { gte, lte } = getCurrentFilterValues();
  // const hasFilter = gte > 0 || (lte !== null && lte < absMax);

  // if (hasFilter) {
  //   minPercent = priceToPercent(gte);
  //   maxPercent = lte ? priceToPercent(lte) : 100;
  //   minPercent = clampPercent(minPercent);
  //   maxPercent = clampPercent(maxPercent);
  //   if (maxPercent - minPercent < minGapPercent) {
  //     maxPercent = Math.min(100, minPercent + minGapPercent);
  //   }
  // }

  // updatePointPosition(minPoint, minPercent);
  // updatePointPosition(maxPoint, maxPercent);


// === RESTORE FROM URL === ONLY IF PRICE FILTER WAS ACTUALLY USED ===
  const { gte, lte } = getCurrentFilterValues();

  // Skip entirely if price filter not in URL OR is default values
  const urlHasPriceFilter = window.location.search.includes('filter.v.price');
  const isDefault = gte <= 0 && (lte === null || lte >= absMax);

  if (!urlHasPriceFilter || isDefault) {
    // Force clean state – no injection, no sync, no events
    minPercent = 0;
    maxPercent = 100;
    updatePointPosition(minPoint, 0);
    updatePointPosition(maxPoint, 100);
    return;
  }

  // Only now restore real user selection
  minPercent = priceToPercent(gte);
  maxPercent = lte ? priceToPercent(lte) : 100;
  minPercent = clampPercent(minPercent);
  maxPercent = clampPercent(maxPercent);
  if (maxPercent - minPercent < minGapPercent) {
    maxPercent = Math.min(100, minPercent + minGapPercent);
  }

  updatePointPosition(minPoint, minPercent);
  updatePointPosition(maxPoint, maxPercent);




  // Initial broadcast to sync inputs
  broadcastChange(false);
  // Do NOT broadcast at init, avoid auto-trigger
  // isUpdating = true;
  // document.querySelectorAll('input[name="filter.v.price.gte"]').forEach(i => i.value = Math.round(percentToPrice(minPercent)));
  // document.querySelectorAll('input[name="filter.v.price.lte"]').forEach(i => i.value = Math.round(percentToPrice(maxPercent)));
  // isUpdating = false;

}

// === INIT + OBSERVE ===
function initAllSliders() {
  document.querySelectorAll('.price-slider-wrap').forEach(initSlider);
}

initAllSliders();

const observer = new MutationObserver(mutations => {
  let shouldReinit = false;
  mutations.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.matches('.price-slider-wrap') || node.querySelector('.price-slider-wrap'))) {
          shouldReinit = true;
        }
      });
    }
  });
  if (shouldReinit) {
    setTimeout(initAllSliders, 100);
    // setTimeout(() => {
    //   isUpdating = true;
    //   initAllSliders();
    //   isUpdating = false;
    // }, 100);

  }
});

observer.observe(document.body, { childList: true, subtree: true });